import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { gluteFaqs } from '../../data/gluteCopy';
export function GluteFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="glute-faq" className="w-full bg-coal" data-id="element-35" data-mp="2sfw7u4e96g03">
      <div className="mx-auto w-full max-w-3xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-36" data-mp="2xa0fkpvces28">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-37" data-mp="326qv9c38jln4">
          Dudas frecuentes
        </p>
        <h2 id="glute-faq" className="mt-5 text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-38" data-mp="36b6zl8x7al08">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 divide-y divide-coal-line border-y border-coal-line" data-id="element-39" data-mp="3g4xjs1mao9a4">
          {gluteFaqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-40" data-mp="1lv3o79borqrp" data-mpi={index}>
                <h3 data-id="element-41" data-mp="3i4zenvsnqsz1">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`glute-faq-${index}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-white outline-none transition-colors duration-150 ease-smooth hover:text-ember focus-visible:ring-2 focus-visible:ring-ember sm:gap-6" data-id="element-42" data-mp="3i5ilohgrrwya">
                    <span className="text-[1rem] font-semibold sm:text-lg" data-id="element-43" data-mp="3w50f5a50fydz">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-ember transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-44" data-mp="3s12h72rf8tmi" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-45" data-mp="2bmkeecberrid">
                  {isOpen && <motion.div id={`glute-faq-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-46" data-mp="2d6c625cwutq4">
                      <p className="pb-6 pr-2 text-[0.95rem] leading-relaxed text-white/55 sm:pr-10 sm:text-base" data-id="element-47" data-mp="1ucyi4k7m7nk0">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}